import { useState } from "react";
import { faqs, trustStats } from "@/mocks/home";

export default function TrustFaq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="shell grid grid-cols-1 gap-12 lg:grid-cols-12">
        {/* Trust 数字区 */}
        <div className="flex flex-col lg:col-span-5">
          <span className="text-xs font-semibold tracking-[0.2em] text-primary-600">
            WHY TRUST · 围观守则
          </span>
          <h2 className="mt-2 font-serif text-2xl font-bold text-foreground-950 md:text-3xl">
            热闹要看得清，更要站得住
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600">
            围观的前提是可信。我们按真实聚集与反应记录现场，标注信源与进展，
            宁可晚一步更新，也不让谣言借热闹上位。
          </p>

          <div className="mt-8 grid grid-cols-2 gap-3">
            {trustStats.map((s, i) => (
              <div
                key={i}
                className={
                  "flex flex-col gap-1 rounded-lg border p-4 " +
                  (s.accent
                    ? "border-accent-300 bg-accent-500 text-background-50"
                    : "border-background-200 bg-background-100")
                }
              >
                <span className="font-serif text-2xl font-black md:text-3xl">{s.value}</span>
                <span
                  className={
                    "text-xs " + (s.accent ? "text-background-50/90" : "text-foreground-600")
                  }
                >
                  {s.label}
                </span>
              </div>
            ))}
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-600">
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-primary-600"></i>
              现场标注时间地点
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-primary-600"></i>
              存疑内容醒目标记
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line text-primary-600"></i>
              进展持续核实
            </span>
          </div>
        </div>

        {/* FAQ 醒目区 */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 border-b border-background-300/70 pb-4">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-question-line text-lg"></i>
            </span>
            <div>
              <h3 className="font-serif text-lg font-bold text-foreground-950">
                关于围观，你可能想问
              </h3>
              <p className="text-xs text-foreground-500">从好奇到边界，一次讲清楚</p>
            </div>
          </div>

          <div className="mt-2 flex flex-col">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={i}
                  className="border-b border-background-200/70"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 py-4 text-left"
                  >
                    <span className="flex items-center gap-3">
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xs font-bold text-secondary-800">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span
                        className={
                          "text-sm font-medium transition-colors md:text-base " +
                          (open ? "text-primary-700" : "text-foreground-900")
                        }
                      >
                        {f.q}
                      </span>
                    </span>
                    <i
                      className={
                        "text-lg text-foreground-500 transition-transform duration-300 " +
                        (open ? "ri-arrow-up-s-line text-primary-600" : "ri-arrow-down-s-line")
                      }
                    ></i>
                  </button>
                  <div
                    className={
                      "grid transition-all duration-300 " +
                      (open ? "grid-rows-[1fr] pb-5 opacity-100" : "grid-rows-[0fr] opacity-0")
                    }
                  >
                    <div className="overflow-hidden pl-10">
                      <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}